export default __webpack_public_path__ + "static/media/Payout.aa928589.png";